<div class="modal-content">
    <div class="modal-header">
        @if(!user){
        <h4 class="modal-title">Add Superadmin</h4>
        }@else{
        <h4 class="modal-title">Edit Superadmin</h4>
        }
        <button class="btn-close py-0" type="button" (click)="close()"></button>
    </div>
    <form class="theme-form" [formGroup]="form" ngNativeValidate>
        <div class="modal-body">
            <label class="col-form-label pt-0">Name</label>
            <div class="row g-2">
                <div class="col-4">
                    <input class="form-control" type="text" required="" placeholder="First name" required
                        formControlName="firstName" />
                    @if (validate && formValidation.isInvalidField(form,'firstName')) {
                    <div class="form-error">
                        <div>{{formValidation.getErrorMessage(form,'firstName')}}</div>
                    </div>
                    }
                </div>
                <div class="col-4">
                    <input class="form-control" type="text"  placeholder="Middle name" 
                        formControlName="middleName" />
                    @if (validate && formValidation.isInvalidField(form,'middleName')) {
                    <div class="form-error">
                        <div>{{formValidation.getErrorMessage(form,'middleName')}}</div>
                    </div>
                    }
                </div>
                <div class="col-4">
                    <input class="form-control" type="text" required="" placeholder="Last name" required
                        formControlName="lastName" />
                    @if (validate && formValidation.isInvalidField(form,'lastName')) {
                    <div class="form-error">
                        <div>{{formValidation.getErrorMessage(form,'lastName')}}</div>
                    </div>
                    }
                </div>
            </div>
            <div class="form-group">
                <label class="col-form-label">Email Address</label>
                <input class="form-control" type="email" required="" placeholder="jhon@email.com" required
                    formControlName="email" />
                @if (validate && formValidation.isInvalidField(form,'email')) {
                <div class="form-error">
                    <div>{{formValidation.getErrorMessage(form,'email')}}</div>
                </div>
                }
            </div>
            @if(!user){
            <div class="form-group">
                <label class="col-form-label">Password</label>
                <div class="form-input position-relative">
                    <input class="form-control" formControlName="password" type="password" name="password" required
                        [type]="show ? 'password' : 'text'" required="" placeholder="*********" />
                    <div class="show-hide">
                        <span (click)="show = !show" [class.show]="show"></span>
                    </div>
                </div>
                @if (validate && formValidation.isInvalidField(form,'password')) {
                <div class="form-error">
                    <div>{{formValidation.getErrorMessage(form,'password')}}</div>
                </div>
                }
            </div>
            }
            <div class="form-group">
                <label class="col-form-label">Phone Number</label>
                <input class="form-control" placeholder="Enter phone number" formControlName="phone" phoneMask
                    maxlength="14" required>
                @if (validate && formValidation.isInvalidField(form,'phone')) {
                <div class="form-error">
                    <div>{{formValidation.getErrorMessage(form,'phone')}}</div>
                </div>
                }
            </div>
        </div>
        <div class="modal-footer">
            @if(!user){
            <button class="btn btn-primary btn-block w-100" type="submit" (click)="register()">
                <span >Create Superadmin</span>
                
            </button>
            }@else{
            <button class="btn btn-primary btn-block w-100" type="submit" (click)="editSuperAdmin()">
                <span >Edit Superadmin</span>
               
            </button>
            }
        </div>
    </form>
</div>
    <app-loader [loading]="isLoading"></app-loader>